import React from 'react'
import { Box, Image, Text, HStack, SimpleGrid, Button } from "@chakra-ui/react";
import gshopy from "../images/gshopy.png";
import licious from "../images/licious.png"
import sephora from "../images/sephora.png"
import purpple from "../images/purpple.png"
const Project = () => {
  return (
    <Box id="projects" textAlign="center" h={'auto'} >
      <HStack width={'100%'} color="white" alignItems={'center'} justifyContent={'center'} fontWeight={'500'} height={['50px', '60px', '70px']} bg={'gray.800'}>
        <Text fontSize={'xl'}>Projects</Text>
      </HStack>
      <Box width={'90%'} margin={'auto'} marginTop='5'>
        <SimpleGrid columns={[1, 1, 2]} height={'auto'}>

          <Box _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
            width={'auto'} height={'auto'} margin='auto' padding='20px'>
            <Image margin='auto' width={[250, 400, 550]} height={[200, 340, 285]} alt='React' src={sephora} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}><u>Sephora.com clone</u></Text>
            <Text fontWeight={'600'} fontSize={['10px', '14px', '16px']} textAlign="center" color={'whiteAlpha.900'}>
              <i>An E-commerce website used to buy beauty products where user can search,sort and filter the products according to their need.</i>
            </Text>
            <Text fontWeight={'800'} marginTop='2' fontSize={['12px', '14px', '16px']} textAlign="center" color={'gray.900'}>TECH STACKS: ReactJs, Redux,Redux-Thunk, Render, Chakra-UI</Text>
            <Box width='300px' margin={'auto'} display='flex' justifyContent={'space-evenly'} marginTop='5'>
              <Button bg={'gray.800'} color='whiteAlpha.900'><a href='https://github.com/gprasadbhat948231/sephora.com' target={'_blank'}>Source Code</a></Button>
              <Button bg={'gray.800'} color='whiteAlpha.900'><a href='https://nemow.vercel.app/' target={'_blank'}>Live Demo</a></Button>
            </Box>
          </Box>

          <Box
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
            width={'auto'} height={'auto'} margin='auto' padding='20px'>
            <Image margin='auto' width={[250, 400, 550]} height={[200, 340, 285]} alt='Javascript' src={purpple} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}><u>Purpple.com clone</u></Text>
            <Text fontWeight={'600'} fontSize={['10px', '14px', '16px']} textAlign="center" color={'whiteAlpha.900'}>
              <i>This is a fully featured MERN collaborative project where we tried to implement the shopping website related to beauty products.</i>
            </Text>
            <Text fontWeight={'800'} marginTop='2' fontSize={['12px', '14px', '16px']} textAlign="center" color={'gray.900'}>TECH STACKS: ReactJs, Redux, NodeJs, Express, Mongoose, MongoDB</Text>
            <Box width='300px' margin={'auto'} display='flex' justifyContent={'space-evenly'} marginTop='5'>
              <Button color='whiteAlpha.900' bg={'gray.800'}><a href='https://github.com/abhiamber/resonant-dinosaurs-925' target={'_blank'}>Source Code</a></Button>
              <Button color='whiteAlpha.900' bg={'gray.800'}><a href='https://frontend-eight-tawny-20.vercel.app/' target={'_blank'}>Live Demo</a></Button>
            </Box>
          </Box>
          <Box margin='auto'
            width={'auto'}
            height={'auto'}
            // border='1px solid'
            padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }} >
            <Image margin='auto' width={[250, 400, 550]} height={[200, 340, 285]} alt='html5' src={gshopy} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}><u>Yoox.com clone</u></Text>
            <Text fontWeight={'600'} fontSize={['10px', '14px', '16px']} textAlign="center" color={'whiteAlpha.900'}>
              <i>This is the E-commerce website you can find the products related to Men and Women. This is the clone of Yoox.com website and placed across the globe.</i>
            </Text>
            <Text fontWeight={'800'} marginTop='2' fontSize={['12px', '14px', '16px']} textAlign="center" color={'gray.900'}>TECH STACKS: React, Chakra-Ui, render.com,React slicks</Text>
            <Box width='300px' margin={'auto'} display='flex' justifyContent={'space-evenly'} marginTop='5'>
              <Button color='whiteAlpha.900' bg={'gray.800'}><a href='https://github.com/gprasadbhat948231/gshopy' target={'_blank'}>Source Code</a></Button>
              <Button color='whiteAlpha.900' bg={'gray.800'}><a href='https://gprasadbhat948231-makes-great-sites.netlify.app/' target={'_blank'}>Live Demo</a></Button>
            </Box>
          </Box>


          <Box width={'auto'} margin='auto' height={'auto'} padding='20px'
            _hover={{ boxShadow: '0px 10px 12px 1px rgba(217,101,52,0.37)' }}
          >
            <Image margin='auto' width={[250, 400, 550]} height={[200, 340, 285]} alt='CSS3' src={licious} />
            <Text fontWeight={'600'} fontSize={['14px', '16px', '22px']} textAlign="center" color={'whiteAlpha.900'}><u>Licious.in clone</u></Text>
            <Text fontWeight={'600'} fontSize={['10px', '14px', '16px']} textAlign="center" color={'whiteAlpha.900'}>
              <i> This is the Restaurant based hotel management system. Where we can order the food online. Get it delivered by a day. It is established all over the country.</i>
            </Text>
            <Text fontWeight={'800'} marginTop='2' fontSize={['12px', '14px', '16px']} textAlign="center" color={'gray.900'}>TECH STACKS: HTML,CSS, Venilla Javascript</Text>
            <Box width='300px' margin={'auto'} display='flex' justifyContent={'space-evenly'} marginTop='5'>
              <Button bg={'gray.800'} color='whiteAlpha.900'><a href='https://github.com/gprasadbhat948231/licious.in-restaurant' target={'_blank'}>Source Code</a></Button>
              <Button bg={'gray.800'} color='whiteAlpha.900'><a href='https://elegant-torte-973965.netlify.app/' target={'_blank'}>Live Demo</a></Button>
            </Box>
          </Box>




        </SimpleGrid>
      </Box>
    </Box>
  )
}

export default Project